import React, { Component, ChangeEvent } from 'react';
import { connect } from 'react-redux';
import { CommonHeader, Loader, ErrorSuccessModal } from '../../components/commons';

import { resetInvoicingError, resetInvoicingSuccess, addInvoiceAction, editInvoiceAction, resetInvoiceStatusCode } from './../../redux/invoicing';
import { resetSession } from '../../redux/auth';
import SwitchInput from './SwitchInput';

let client_code: number;
interface State {
    column?: any[];
    uploadData: any[];
    showModal: boolean;
}

interface Props {
    DispatchResetInvoicingSuccess: () => void;
    resetInvoicingError: () => void;
    dispatchAddInvoiceAction: (data: any) => void;
    dispatchEditInvoiceAction: (data: any) => void;
    resetInvoiceStatusCode: (data: any) => void;
    dispatchResetSession: (data: any) => void;
    token: string;
    success: number;
    result: any;
    message: string;
    error: boolean;
    columnList: any;
    finalColumnList: any;
    type: any;
    client_code: any;
    statusCode: any;
    invoiceAction?: string;
    invoice_id?: any;
    fetching?: boolean;
    history?: any;
}


type itemType = {
    id?: number;
    column_name?: string;
    name: any;
    data_type?: string;
    column_value?: any;
    placeholder?: string;
}


class InvoiceInput extends Component<Props, State, itemType> {

    state = {
        column: [this.props.finalColumnList],
        uploadData: [],
        showModal: false
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.finalColumnList !== this.props.finalColumnList) {
            this.setState({ column: [this.props.finalColumnList] })
        }

        if (this.props.error) {
            // this.setState({column: [this.props.finalColumnList]})
        }
    }

    handleErrorModal = () => {

        const {
            success,
            statusCode,
            error
        } = this.props
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired"
                        buttonText="Logout"
                        onPress={() => {
                            // dispatchResetSession();
                            this.props.resetInvoicingError();
                        }}
                        statusCode={statusCode}
                    />
                )
            } else if (error && statusCode !== 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message='something went wrong'
                        buttonText="OK"
                        onPress={() => this.props.resetInvoicingError()}
                    />
                )
            }
        }

        if (success === 1) {
            return (
                <ErrorSuccessModal
                    type="success"
                    isOpen={success === 1}
                    title="Success"
                    message="Invoice Updated Successfully!"
                    buttonText="OK"
                    onPress={() => {
                        this.props.DispatchResetInvoicingSuccess();
                        window.history.back()
                    }}
                    statusCode={statusCode}
                />
            )
        }

        return false;
    }


    addRow = () => {
        let {
            columnList: {
                expenses = []
            } = {}
        } = {} = this.props
        let newList = JSON.parse(JSON.stringify(this.state.column))
        newList.push(this.props.finalColumnList)
        this.setState({
            column: newList
        })
    }

    removeRow = (key: number) => {
        let newCol = [...this.state.column];
        newCol.splice(key, 1);
        this.setState({ column: newCol });
    }
    uploadedUrl = (url: any, rowNumber: number) => {

        let data = {
            id: 100,
            column_name: 'upload',
            name: 'File Upload',
            data_type: 'string',
            column_value: url,
            placeholder: 'File Upload'
        }

        let newData = JSON.parse(JSON.stringify(this.state.column))

        newData[rowNumber].push(data)

        this.setState({
            column: newData
        })
        //this.state.column[rIdx]

    }

    testJSON = (text: any) => {
        if (typeof text !== "string") {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        }
        catch (error) {
            return false;
        }
    }

    handleUpload = (value: any, row: number, index: number, name?: string, file_type?: string) => {

        let newData = JSON.parse(JSON.stringify(this.state.column))

        let oldValue = newData[row][index].column_value
        let newArr = []

        let newObj = {
            column_value: value || '',
            data_type: file_type || '',
            name: name || ''
        }

        if (this.testJSON(oldValue) && oldValue.length) newArr = JSON.parse(oldValue)

        newArr.push(newObj)
        newData[row][index].column_value = JSON.stringify(newArr)
        this.setState({
            column: newData
        })

    }
    handleRemoveUpload = (itemIndex: number, row: number, index: number) => {

        let newData = JSON.parse(JSON.stringify(this.state.column))
        let oldValue = newData[row][index].column_value
        let newArr = []

        if (this.testJSON(oldValue) && oldValue.length) {

            newArr = JSON.parse(oldValue)
            if (newArr.length === 1) {
                newData[row][index].column_value = ''

            } else {
                newArr.splice(itemIndex, 1)
                newData[row][index].column_value = JSON.stringify(newArr)
            }

            this.setState({
                column: newData
            })
        }

    }

    handleChange = (value: any, row: number, index: number, name?: string, file_type?: string) => {

        let newData = JSON.parse(JSON.stringify(this.state.column))

        if (value === "Invalid date") {
            newData[row][index].column_value = ''
        } else {
            newData[row][index].column_value = value
        }



        if (name) newData[row][index].name = name

        if (file_type) newData[row][index].data_type = file_type

        this.setState({
            column: newData
        })
    }

    handleSave = () => {
        const {
            dispatchAddInvoiceAction,
            dispatchEditInvoiceAction,
            token,
            invoiceAction,
        } = {} = this.props

        const search = window.location.search;

        const type = new URLSearchParams(search).get('type');
        const invoice_id = new URLSearchParams(search).get('invoice_id');
        let url = window.location.pathname.split('/')

        client_code = Number(url[url.length - 1])
        let req: any = {
            type,
            client_code,
            data: this.state.column,
            token
        }

        if (invoiceAction === 'edit') {
            req.invoice_id = Number(invoice_id)
            req.data = this.state.column[0]
            dispatchEditInvoiceAction(req)
        }
        if (!invoiceAction) dispatchAddInvoiceAction(req);


        //need to use after success message after save action
        if (this.props.statusCode && this.props.statusCode === 200) {

            this.setState({
                column: [this.props.finalColumnList],
                showModal: true
            })
            this.props.DispatchResetInvoicingSuccess()
            this.props.resetInvoicingError()
            // this.handleErrorModal()
        }
    }

    renderInput = () => {
        const { column = [] } = this.state;
        const { invoiceAction = '' } = this.props;


        return <>
            {column && column !== undefined && column.length && column.map((row, rIdx) => {
                return <div className="invoice-block" key={rIdx}>
                    <div className="col-12 d-flex justify-content-between mb-2 ">
                        <span className="number-circle">{rIdx + 1}</span>
                        {column.length > 1 && <span className="delete" onClick={() => this.removeRow(rIdx)}><i className="fas fa-times-circle"></i></span>}
                    </div>
                    <div className="grid-container container">
                        {

                            row.map((item: itemType, index: number) => {
                                return (

                                    <SwitchInput
                                        item={item}
                                        activeColumn={this.state.column[rIdx][index].column_name}
                                        callback={this.handleChange}
                                        handleUpload={this.handleUpload}
                                        handleRemoveUpload={this.handleRemoveUpload}
                                        rIdx={rIdx}
                                        index={index}
                                        client_code={client_code}
                                    />



                                )
                            })
                        }
                    </div>
                </div>
            })
            }

            <div className="row mt-3 ">
                <div
                    className={
                        `col-12 d-flex 
                            ${ invoiceAction ?
                            'justify-content-end' : 'justify-content-between'
                        }
                        `
                    }
                >
                    {column?.length < 10 && !(invoiceAction === 'edit') && <button className="btn btn-outline-secondary" onClick={() => this.addRow()}><i className="fas fa-plus"></i> Add Row</button>}


                    <button className="btn btn-secondary-outline mr-3 ml-auto" onClick={() => window.history.back()}>Cancel</button>

                    <button className="btn btn-primary" onClick={this.handleSave}><i className="fas fa-save"></i> Save</button>
                </div>
            </div>

        </>
    }
    render() {
        const { invoiceAction = '', type = '' } = this.props
        const { column = [] } = this.state

        return (
            <>
                {invoiceAction === 'edit' ?
                    <><h2>Edit {type}</h2>
                        <div className="page-title"></div>
                    </> :
                    <><h2>Add {type}</h2>
                        <div className="page-title"></div>
                    </>}
                {
                    column && column.length && column[0] !== undefined ?
                        this.renderInput() : null
                }

                {this.props.message ? this.props.message : ''}
                {this.props.fetching && <Loader />}
                {this.state.showModal ? this.handleErrorModal() : null}
            </>

        )
    }
}

const mapStateToProps = (state: any) => ({
    token: state.auth.token,
    fetching: state.invoicing.fetching,
    error: state.invoicing.error,
    success: state.invoicing.success,
    message: state.invoicing.message,
    result: state.invoicing.result,
    columnList: state.invoicing.columnList,
    clientList: state.auth.clientList,
    statusCode: state.invoicing.statusCode
})

const mapDispatchToProps = (dispatch: any) => ({
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchAddInvoiceAction: (data: any) => dispatch(addInvoiceAction(data)),
    dispatchEditInvoiceAction: (data: any) => dispatch(editInvoiceAction(data)),
    resetInvoicingError: () => dispatch(resetInvoicingError()),
    DispatchResetInvoicingSuccess: () => dispatch(resetInvoicingSuccess()),
    resetInvoiceStatusCode: () => dispatch(resetInvoiceStatusCode())

})

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceInput)